import { InputTypes } from "../inputs/constants";

export const filters = [
  {
    description: "Minimum Assessed Improvement Value",
    key: "assessedImprovementValueMin",
    label: "Minimum Assessed Improvement Value",
    type: InputTypes.NUMBER,
    filterType: "currency",
  },
  {
    description: "Maximum Assessed Improvement Value",
    key: "assessedImprovementValueMax",
    label: "Maximum Assessed Improvement Value",
    type: InputTypes.NUMBER,
    filterType: "currency",
  },
  {
    description: "Minimum Assessed Improvement Value",
    key: "assessedLandValueMin",
    label: "Minimum Assessed Improvement Value",
    type: InputTypes.NUMBER,
    filterType: "currency",
  },
  {
    description: "Maximum Assessed Land Value",
    key: "assessedLandValueMax",
    label: "Maximum Assessed Land Value",
    type: InputTypes.NUMBER,
    filterType: "currency",
  },
  {
    description: "Minimum Assessed Value",
    key: "assessedValueMin",
    label: "Minimum Assessed Value",
    type: InputTypes.NUMBER,
    filterType: "currency",
  },
  {
    description: "Maximum Assessed Value",
    key: "assessedValueMax",
    label: "Maximum Assessed Value",
    type: InputTypes.NUMBER,
    filterType: "currency",
  },
  {
    description:
      "Indicates whether the property has an attic and possibly its specifications.",
    key: "attic",
    label: "Attic",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
    filterType: "boolean",
  },
  {
    description: "Minimum Auction Date",
    key: "auctionDateMin",
    label: "Minimum Auction Date",
    type: InputTypes.DATE_PICKER,
    filterType: "date",
  },
  {
    description: "Maximum Auction Date",
    key: "auctionDateMax",
    label: "Maximum Auction Date",
    type: InputTypes.DATE_PICKER,
    filterType: "date",
  },
  {
    description: "Indicates whether the owner has filed for bankruptcy.",
    key: "bankruptcy",
    label: "Bankruptcy",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
    filterType: "boolean",
  },
  {
    description: "Minimum Bankruptcy Recording Date",
    key: "bankruptcyRecordingDateMin",
    label: "Minimum Bankruptcy Recording Date",
    type: InputTypes.DATE_PICKER,
    filterType: "date",
  },
  {
    description: "Maximum Bankruptcy Recording Date",
    key: "bankruptcyRecordingDateMax",
    label: "Maximum Bankruptcy Recording Date",
    type: InputTypes.DATE_PICKER,
    filterType: "date",
  },
  {
    description:
      "Indicates whether the property has a basement and its specifications.",
    key: "basement",
    label: "Basement",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
    filterType: "boolean",
  },
  {
    description: "Minimum Number Of Bathrooms",
    key: "bathroomsMin",
    label: "Minimum Number Of Bathrooms",
    type: InputTypes.NUMBER,
    filterType: "number",
  },
  {
    description: "Maximum Number Of Bathrooms",
    key: "bathroomsMax",
    label: "Maximum Number Of Bathrooms",
    type: InputTypes.NUMBER,
    filterType: "number",
  },
  {
    description: "Minimum Number Of Bedrooms",
    key: "bedroomsMin",
    label: "Minimum Number Of Bedrooms",
    type: InputTypes.NUMBER,
    filterType: "number",
  },
  {
    description: "Maximum Number Of Bedrooms",
    key: "bedroomsMax",
    label: "Maximum Number Of Bedrooms",
    type: InputTypes.NUMBER,
    filterType: "number",
  },
  {
    description:
      "Indicates whether the property is listed below its estimated market value.",
    key: "belowMarketPrice",
    label: "Below Market Price",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
    filterType: "boolean",
  },
  {
    description: "Minimum Below Market Price Rate",
    key: "belowMarketPriceRateMin",
    label: "Minimum Below Market Price Rate",
    type: InputTypes.NUMBER,
    filterType: "percentage",
  },
  {
    description: "Maximum Below Market Price Rate",
    key: "belowMarketPriceRateMax",
    label: "Maximum Below Market Price Rate",
    type: InputTypes.NUMBER,
    filterType: "percentage",
  },
  {
    description: "Indicates whether the owner is associated with a business.",
    key: "businessOwner",
    label: "Business Owner",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
    filterType: "boolean",
  },
  {
    description: "Identifies if the property was purchased by a cash buyer.",
    key: "cashBuyer",
    label: "Cash Buyer",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
    filterType: "boolean",
  },
  {
    description: "Does the property have a pool",
    key: "pool",
    label: "Pool",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
    filterType: "boolean",
  },
];

export const formatFilters = (filters = []) => {
  return filters.reduce((acc, filter) => {
    const { key, value } = filter;
    if (value !== undefined && value !== null && value !== "") {
      // Convert Date objects to epoch timestamp if they exist
      if (value instanceof Date) {
        acc[key] = value.getTime();
      } else {
        acc[key] = value;
      }
    }

    return acc;
  }, {});
};
